export default __webpack_public_path__ + "static/media/healthylab.6470bf58.png";